import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  customerVerification: {
    certificates: [],
    error: '',
    loading: false,
    verified: false,
  },
  emailValidation: {
    emailExists: false,
    error: '',
    hasB2CCredentials: false,
    hasGroupPolicy: false,
    loading: false,
    validated: false,
  },
  errorSubmitting: false,
  refreshingPets: false,
  submitting: false,
  successSubmitting: false,
  updateCustomerEmail: {
    error: '',
    loading: false,
    success: false,
    updated: false,
  },
  zipCodeValidation: {
    isValid: null,
    isValidating: false,
  },
};

export default handleActions({
  REFRESH_PETS_AFTER_SUBMIT: (state) => ({
    ...state,
    refreshingPets: true,
  }),

  REFRESH_PETS_AFTER_SUBMIT_DONE: (state) => ({
    ...state,
    refreshingPets: false,
  }),

  RESET_NO_MATCH_ERROR: (state) => ({
    ...state,
    customerVerification: {
      certificates: [],
      error: '',
      loading: false,
      verified: false,
    },
  }),

  RESET_PET_DEMOGRAPHICS_SUBMIT: (state) => ({
    ...state,
    errorSubmitting: false,
    refreshingPets: false,
    submitting: false,
    successSubmitting: false,
  }),

  SUBMIT_PET_DEMOGRAPHICS: (state) => ({
    ...state,
    errorSubmitting: false,
    submitting: true,
    successSubmitting: false,
  }),

  SUBMIT_PET_DEMOGRAPHICS_FAILURE: (state) => ({
    ...state,
    errorSubmitting: true,
    submitting: false,
    successSubmitting: false,
  }),

  SUBMIT_PET_DEMOGRAPHICS_SUCCESS: (state) => ({
    ...state,
    errorSubmitting: false,
    submitting: false,
    successSubmitting: true,
  }),

  UPDATE_CUSTOMER_EMAIL: (state) => ({
    ...state,
    updateCustomerEmail: {
      ...state.updateCustomerEmail,
      error: '',
      loading: true,
      success: false,
      updated: false,
    },
  }),

  UPDATE_CUSTOMER_EMAIL_FAILED: (state, { payload }) => ({
    ...state,
    updateCustomerEmail: {
      ...state.updateCustomerEmail,
      error: payload.error,
      loading: false,
      success: false,
      updated: false,
    },
  }),

  UPDATE_CUSTOMER_EMAIL_SUCCESS: (state) => ({
    ...state,
    updateCustomerEmail: {
      ...state.updateCustomerEmail,
      error: '',
      loading: false,
      success: true,
      updated: true,
    },
  }),

  VALIDATE_CERTIFICATE_ZIP_CODE_ATTEMPT: (state) => ({
    ...state,
    zipCodeValidation: {
      isValid: null,
      isValidating: true,
    },
  }),

  VALIDATE_CERTIFICATE_ZIP_CODE_FAILED: (state) => ({
    ...state,
    zipCodeValidation: {
      isValid: false,
      isValidating: false,
    },
  }),

  VALIDATE_CERTIFICATE_ZIP_CODE_SUCCESS: (state) => ({
    ...state,
    zipCodeValidation: {
      isValid: true,
      isValidating: false,
    },
  }),

  VALIDATE_EMAIL: (state) => ({
    ...state,
    emailValidation: {
      ...state.emailValidation,
      error: '',
      loading: true,
      validated: false,
    },
  }),

  VALIDATE_EMAIL_FAILED: (state, { payload }) => ({
    ...state,
    emailValidation: {
      ...state.emailValidation,
      error: payload.error,
      loading: false,
      validated: false,
    },
  }),

  VALIDATE_EMAIL_SUCCESS: (state, { payload }) => ({
    ...state,
    emailValidation: {
      ...state.emailValidation,
      emailExists: payload.emailExists,
      error: '',
      hasB2CCredentials: payload.hasB2CCredentials,
      hasGroupPolicy: payload.hasGroupPolicy,
      loading: false,
      validated: true,
    },
  }),

  VERIFY_CUSTOMER: (state) => ({
    ...state,
    customerVerification: {
      certificates: [],
      error: '',
      loading: true,
      verified: false,
    },
  }),

  VERIFY_CUSTOMER_FAILED: (state, { payload }) => ({
    ...state,
    customerVerification: {
      ...state.customerVerification,
      error: payload.error,
      loading: false,
      verified: false,
    },
  }),

  VERIFY_CUSTOMER_SUCCESS: (state, { payload }) => ({
    ...state,
    customerVerification: {
      certificates: payload.certificates,
      error: '',
      loading: false,
      verified: true,
    },
  }),
}, INITIAL_STATE);
